module.exports = __webpack_public_path__ + "static/mercadolibre.c8ba64db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/mercadolibre.svg
// module id = 623
// module chunks = 35783957827783